import { Box, Typography } from "@mui/material";

export function CopyrightInfoMobile() {
    return (
        <Box
            sx={{
                opacity: 1,
                color: '#FFFFFF',
                minWidth: '100%',
            }}
        >
            <Typography
                flexWrap="wrap"
                style={{
                    opacity: 0.87,
                    fontSize: '14px',
                    paddingTop: '5px',
                    backgroundColor: 'rgb(0,0,0)',
                    textAlign: 'center',
                }}
            >
                Options Strategy Analyser & Portfolio Management
            </Typography>
            <Typography
                sx={{
                    opacity: 0.87,
                    fontSize: '12px',
                    paddingBottom: '5px',
                    backgroundColor: 'rgb(0,0,0)',
                    fontWeight: 'bold',
                    textAlign: 'center',
                }}
            >
                OSA @ 2024 - 2026
            </Typography>
        </Box>
    );
}